import React from "react";
import { useSelector} from "react-redux";
import MoonLoader from "react-spinners/MoonLoader";
import style from "./DetectionResult.module.css";

const DetectionResult = ({ isDisplay = true, imageCount,activeButton="Container",llmLoading,llmMessage }) => {

  const {cityName} = useSelector((state) => state.model);
  const { isLoading, inferenceTime,detectionImage, numBoxes, isDetecting, location } = useSelector((state) => state.detection);
  
  const isContainer = activeButton === "Container" ? true : false;
  return (
    <div className={style.detectionResult}>
      <h2>📀 Detection Result </h2>
      <p>🏙️ City-Model: {cityName}</p>
      {!isLoading &&  inferenceTime > 0 && isContainer &&(
        <>
        <p>
          ⌛ Inference Time:{" "}
          {inferenceTime < 1000
            ? `${inferenceTime} ms`
            : `${(inferenceTime / 1000).toFixed(2)} seconds`}{" "}
        </p>
        <p> Detected objects: {numBoxes} </p>
        </>
      )}
      {!isLoading && isDetecting && location !== null && (
        <p>
          🌎 Lat: {location.latitude} || Lon: {location.longitude}
        </p>

      )} 
      {imageCount!== undefined  && (
        <p className={style.serverCount}>
          🔄 📟: {imageCount}
        </p>
      )}
      {isDisplay && (
        <>
        <p className={style.llmMessage}>
          {llmLoading && <MoonLoader color="#3D550C" />}
          {!llmLoading && llmMessage}
        </p>
        <div className="imageContainer">
          {isLoading && <MoonLoader color="#3D550C" />}
          {!isLoading && detectionImage && (
            <img src={detectionImage} alt="Uploaded" />
          )}
        </div>
        </>
      )}
    </div>
  );
};

export default DetectionResult;
